module.exports = __webpack_public_path__ + "media/top/bg-478f21e4.png";